import React from 'react';
import { DISHOP_GREEN, LOYALTY, PROMOTION_DELIVERY_FREE } from '../../../constants';
import { useAppSelector } from '../../../redux/hook';
import store from '../../../redux/store';
import { showMessageModal } from '../../../redux/actions';
import MinCartPriceInfo from './MinCartPriceInfo';
import SkeletonRow from '../../Skeleton/SkeletonRow.view';
import { deletePromotion } from '../Order.services';

type OrderPromotionProps = {
  promotion: any;
  commande: any;
  promotionType: string;
  prefix: string;
  isLoading: boolean;
  freeDelivery?: boolean;
  deletable?: boolean;
  nbUsed?: number;
  promoPath?: string;
};

export default function OrderPromotion({
  promotion,
  commande,
  promotionType,
  prefix,
  isLoading,
  freeDelivery = false,
  deletable = false,
  nbUsed,
  promoPath,
}: OrderPromotionProps) {
  const { secondaryColor, name } = useAppSelector(
    (state) => state.configurationReducer
  );

  const isLoyalty = promotion?.promoCode === LOYALTY;
  const isFreeDelivery = promotion?.type === PROMOTION_DELIVERY_FREE;
  const showDeleteIcon =
    deletable && !commande && promoPath && nbUsed == null;
  const trashIconColor = promotion?.minBasketPrice ? 'red' : DISHOP_GREEN;

  const getPromotionLabel = () => {
    if (isLoyalty) return `Fidélité ${name ?? ''}`;
    if (isFreeDelivery || freeDelivery) return 'Livraison offerte';
    return `Promotion ${promotion?.promoCode}`;
  };

  const handleDeleteClick = (e: React.MouseEvent) => {
    e.preventDefault();

    store.dispatch(
      showMessageModal('Confirmer la suppression du code promo ?', {
        showCancel: true,
        onClick: async () => {
          await deletePromotion(promoPath as string);
          store.dispatch(showMessageModal(null));
        },
      })
    );
  };

  return (
    <div
      className={`row ${!commande && promotion?.minBasketPrice && 'strike-through-price'
        }`}
    >
      <SkeletonRow
        label={
          <div
            className='no-localization'
            style={{
              color: !commande && !promotion?.minBasketPrice && secondaryColor,
            }}
          >
            <span className='d-inline-flex align-items-center'>
              {getPromotionLabel()}
              {promotion?.minBasketPrice > 0 && !commande && (
                <MinCartPriceInfo
                  promoType={isLoyalty ? 'loyalty' : 'code-promo'}
                  minBasketPrice={promotion?.minBasketPrice}
                />
              )}
              {showDeleteIcon && (
                <a
                  href='#'
                  className='ml-2'
                  onClick={handleDeleteClick}
                  aria-label='Retirer le code promotionnel'
                >
                  <i
                    className='far fa-trash-alt'
                    style={{ color: trashIconColor }}
                  />
                </a>
              )}
            </span>
          </div>
        }
        amount={
          <div
            className='text-right'
            style={{
              color: !commande && !promotion?.minBasketPrice && secondaryColor,
            }}
          >
            {prefix}
            {promotionType}
          </div>
        }
        isLoading={isLoading}
      />
    </div>
  );
}
